import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { i18n } from './i18n/i18n'

createApp(App).use(i18n).use(store).use(router).use(AOS.init({ duration: 2000, easing: 'ease' })).mount('#app')
